/** Shared inline styles for the Knowledge Base editors. */
export const labelStyle = {
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.05em',
};
